module.exports = __webpack_public_path__ + "img/kyc.48624c39.svg";